export default __webpack_public_path__ + "static/media/mail.ffa34d05.svg";